/**
 * 菜单管理接口
 **/
import { Injectable } from '@angular/core';
import { SwHttpClientService } from 'src/app/librarys/serves/sw-http-client.service';
import { environment } from 'src/environments/environment';
import { HttpClient, HttpHeaders } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class MenuManagementService {
   //基础平台微服务api
   prefix: string = environment.seekerWebAPI;

   //文件处理微服务api
   filefix: string = environment.fileWebAPI;
 
   //任务调度微服务api
   schedulefix: string = environment.scheduleWebApi;
 
   constructor(
     private http: SwHttpClientService,
     private httpClient: HttpClient,
   ) {
   }

  //#region 菜单管理接口
  /**
   * 加载菜单管理表格数据
   * @param param
   * @returns {Observable<any>}
   */
  queryFunctionPageList(param) {
    const url = this.prefix + 'function/queryPageList';
    return this.http.Post(url, param);
  }

  /**
   * 删除菜单管理表格数据
   * @param param
   * @returns {Observable<any>}
   */
  deleteFunction(param) {
    const url = this.prefix + 'function/deleteBatch';
    return this.http.Post(url, param);
  }

  /**
   * 修改，启用，禁用菜单管理表格数据
   * @param param
   * @returns {Observable<any>}
   */
  updateFunction(param) {
    const url = this.prefix + 'function/updateById';
    return this.http.Post(url, param);
  }

  /**
   * 获取单个菜单
   * @param param
   * @returns {Observable<any>}
   */
  getFunction(param) {
    const url = this.prefix + 'function/queryById';
    return this.http.Post(url, param);
  }

  /**
   * 保存单个菜单
   * @param param
   * @returns {Observable<any>}
   */
  saveFunction(param) {
    const url = this.prefix + 'function/save';
    return this.http.Post(url, param);
  }

  //#endregion


}
